var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product",on:{"click":function($event){return _vm.add()}}},[_vm._v(" "+_vm._s(_vm.product.productName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }